export default __webpack_public_path__ + "static/Regina Cargo Pants-b1c0a44dd477a75f84a1c0af3636d40a.webp";